import React, {useEffect} from 'react';
import Ticker from "./components/ticker.jsx";
import Balance from "./components/balance.jsx";
import Orders from "./components/orders.jsx";
import Graph from "./components/graph.jsx";

function App() {

    const PageHeader = () => {
        if (window.demoChartPage) {
            return <div></div>
        } else {
            return <div className="account-header">
                <div className="account-header__main">
                    <div className="account-header__main-logo account-header__main-logo--binance"/>
                    <div className="account-header__main-name">BTC/USDT</div>
                </div>
                <div className="account-header__ticker">
                    <Ticker/>
                </div>
                <div className="account-header__balance">
                    <Balance/>
                </div>
            </div>;
        }
    };

    return (
        <div>

            <PageHeader/>

            <Graph/>

            <Orders/>
        </div>
    );
}

export default App;
